import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import { Button } from "@mui/material";

interface Props {
  selectedIds: string[];
  onRemoveCompanies: (ids: string[]) => void;
}

const DataRequestTemplateCompaniesGridToolbar = ({ selectedIds, onRemoveCompanies }: Props) => {
  return (
    <Button color="error" variant="text" startIcon={<DeleteIcon />} onClick={() => onRemoveCompanies(selectedIds)}>
      Delete
    </Button>
  );
};

export default DataRequestTemplateCompaniesGridToolbar;
